











import { defineComponent } from '@nuxtjs/composition-api';
import UCProductHeroSection from '@shared/components/@atoms/UCProductHeroSection/UCProductHeroSection.vue';
import UCRichTextDisplay from '@shared/components/@atoms/UCRichTextDisplay/UCRichTextDisplay.vue';
import UCSkeletonShimmer from '@shared/components/@atoms/UCSkeletonShimmer/UCSkeletonShimmer.vue';

export default defineComponent({
  name: 'UCProductDetails',
  components: {
    UCProductHeroSection,
    UCRichTextDisplay,
    UCSkeletonShimmer,
  },
  props: {
    descriptionHtml: {
      type: String,
      default: '',
    },
    partNumber: {
      type: String,
      default: '',
    },
    partNumberLabel: {
      type: String,
      default: 'Part Number:',
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    hasPartNumber(): boolean {
      return !!this.partNumber;
    },
  },
});
